<div class="form-grid-new terra-error-style">
  <!-- Country -->
  <div class="terra-form-field-wrapper">
    <label for="aucBankCountryId" class="text-input-label">The bank is located in</label>
    <ng-container *ngIf="countries$ | async as countries">
      <terra-country-auto-complete inputId="aucBankCountryId" [formGroupNameValue]="partialFormName" controlName="countryId"
                                   placeholderText="Select country" [countriesList]="countries" (changedCountry)="countrySelected($event)">
      </terra-country-auto-complete>
    </ng-container>
  </div>

  <div class="terra-form-field-wrapper currency-wrapper" *ngIf="enablePreferredCurrency">
    <label for="ddlCurrency" class="currency-label text-input-label">
      Currency for distributions payments
    </label>
    <mat-form-field appearance="outline" class="currency-ddl-wrapper">
      <mat-select id="ddlCurrency" placeholder="Select" [formControl]="clientBankAccountForm.get('preferredCurrency')"
                  [compareWith]="currencyCompareFn">
        <mat-option *ngFor="let currency of currencies$ | async" [value]="currency">
          {{ currency.symbol }} {{ currency.iso }}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="clientBankAccountForm.get('preferredCurrency').hasError('required')">
        Required
      </mat-error>
    </mat-form-field>
  </div>

  <ng-container *ngIf="enablePreferredCurrency && clientBankAccountForm.get('preferredCurrency').value && selectedCountry?.defaultCurrency">
    <!-- Placeholder for notifications, explanations etc. -->
    <div class="full-width">
      <ng-content select=".injected-currency-information"></ng-content>
    </div>
  </ng-container>

  <!-- Loader -->
  <div class="loader-wrapper full-width" *ngIf="showInternalLoader">
    <terra-loader></terra-loader>
  </div>

  <ng-container *ngIf="selectedCountry && (!enablePreferredCurrency || clientBankAccountForm.get('preferredCurrency')?.value)" [ngSwitch]="selectedCountry.code">
    <!-- Default bank account fields -->
    <ng-container *ngSwitchDefault>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field fieldTitle="Bank name" fieldName="bankName" [control]="clientBankAccountForm.get('bankName')"
                            class="lo_sensitive"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                            [control]="clientBankAccountForm.get('accountNumber')" class="lo_sensitive"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ANTSGB2L" class="lo_sensitive">
        </terra-swift-field>
      </div>
    </ng-container>
    <!-- Canada  -->
    <ng-container *ngSwitchCase="'CA'">
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field fieldTitle="Bank name" fieldName="bankName" [control]="clientBankAccountForm.get('bankName')">
        </terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Institution number" fieldName="canadaInstitutionNumber"
                            [control]="clientBankAccountForm.get('canadaInstitutionNumber')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Transit number" fieldName="canadaTransitNumber"
                            [control]="clientBankAccountForm.get('canadaTransitNumber')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                            [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. AZGRCAMM">
        </terra-swift-field>
      </div>
    </ng-container>

    <!-- Israel -->
    <ng-container *ngSwitchCase="'IL'" class="new-grid-line full-width">
      <mat-tab-group class="full-width" [selectedIndex]="showInternationalFields ? 1 : 0" (selectedTabChange)="toggleUIFieldsLogic($event)"
                     dynamicHeight="true" animationDuration="0ms"  mat-stretch-tabs="false" mat-align-tabs="start">
        <mat-tab [disabled]="isReadOnlyMode || disableLocalFormatTab" label="Local format">
          <div class="form-grid-new tab-grid" [@fadeInOut]>
            <div class="terra-form-field-wrapper">
              <terra-israel-bank-select-field fieldName="bankName" [control]="clientBankAccountForm.get('bankCode')"
                                              (bankNameChanged)="setBankName($event)"></terra-israel-bank-select-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-custom-field type="tel" autocomplete="off" fieldTitle="Bank branch code" fieldName="bankBranchCode"
                                  [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                                  [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
            </div>
          </div>
        </mat-tab>
        <mat-tab [disabled]="isReadOnlyMode" label="IBAN">
          <p *ngIf="disableLocalFormatTab" class="info-message">
            <ng-container *ngTemplateOutlet="localFormatNotAllowed"></ng-container>
          </p>
          <div class="form-grid-new tab-grid" [@fadeInOut]>
            <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}"
                 *ngIf="isForceBankNameAndBranchCode">
              <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                                  [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
            </div>
            <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
                 *ngIf="isForceBankNameAndBranchCode">
              <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                                  fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-iban-field [control]="clientBankAccountForm.get('iban')" inputId="txtIbanIL"
                                placeholder="e.g. IL62 0108 0000 0009 9999 999" [length]="23"></terra-iban-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. POALILIT"></terra-swift-field>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>

    <!-- United States -->
    <ng-container *ngSwitchCase="'US'">
      <div class="payment-method-container block-line-grid">
        <div class="payment-method-label">
          <label class="payment-method-label">Payment Method</label>
          <mat-icon class="notranslate" color="primary" matTooltipClass="terra-tooltip" matTooltipPosition="right" matTooltip="{{paymentTypeTooltip}}">help</mat-icon>
        </div>
        <terra-radio-buttons [control]="clientBankAccountForm.get('paymentType')" [details]="paymentMethodDetails">
        </terra-radio-buttons>
      </div>

      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <ng-container *ngIf="clientBankAccountForm.get('paymentType').value === CrePaymentType.Ach">
          <terra-us-routing-number-field [control]="clientBankAccountForm.get('usabaRoutingNumber')" placeholder="e.g. 122105155">
          </terra-us-routing-number-field>
        </ng-container>
        <ng-container *ngIf="clientBankAccountForm.get('paymentType').value === CrePaymentType.Wire">
          <terra-fedwire-routing-number-field [control]="clientBankAccountForm.get('frn')" placeholder="e.g. 122105155">
          </terra-fedwire-routing-number-field>
          <mat-error *ngIf="clientBankAccountForm.errors?.minNumValuesRequired">Please enter a valid Wire routing number</mat-error>
        </ng-container>
      </div>

      <div class="terra-form-field-wrapper" *ngIf="clientBankAccountForm.get('paymentType').value === CrePaymentType.Ach">
        <label for="ddlAccountType" class="text-input-label">
          Account Type
        </label>
        <mat-form-field appearance="outline">
          <mat-select id="ddlAccountType" placeholder="Select" [formControl]="clientBankAccountForm.get('checkingOrSavingsType')" [hideSingleSelectionIndicator]="true">
            <mat-option *ngFor="let accountType of checkingOrSavingsTypes" [value]="accountType">
              {{ CheckingOrSavingsType.toString(accountType) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ng-container>
        <div class="terra-form-field-wrapper" [@fadeInOut]>
          <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account Number" fieldName="accountNumber"
                              [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
        </div>
        <div class="terra-form-field-wrapper" [@fadeInOut]>
          <terra-custom-field
            type="tel"
            autocomplete="off"
            fieldTitle="Confirm Account Number"
            fieldName="confirmAccountNumber"
            [control]="clientBankAccountForm.get('confirmAccountNumber')"
            customError="confirmedValidator"
            customErrorMessage="Please confirm your account number">
          </terra-custom-field>

        </div>
      </ng-container>

      <!-- Wire memo OBI -->
      <div class="terra-form-field-wrapper triple-field" [@fadeInOut]>
        <label for="memo" class="text-input-label">Memo / Special Instruction (optional)
          <mat-icon class="info-icon-tooltip" pTooltip="{{memoTooltipText}}" tooltipPosition="top">help_outline</mat-icon>
        </label>
        <mat-form-field appearance="outline">
          <input matInput #memo id="memo" type="text" [formControl]="clientBankAccountForm.get('memo')" placeholder="e.g Real Estate inc. Account Number: 123456789"
                 maxlength="{{memoLength}}"/>
          <span matSuffix>{{ (memo.value?.length || 0) }}/{{ memoLength }}</span>
          <mat-error *ngIf="clientBankAccountForm.get('memo')?.hasError('maxlength')">
            Enter a description up to {{ memoLength }} characters
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <!-- United Kingdom -->
    <ng-container *ngSwitchCase="'GB'" class="new-grid-line full-width">
      <mat-tab-group class="full-width" color="primary" [selectedIndex]="showInternationalFields ? 1 : 0"
                     (selectedTabChange)="toggleUIFieldsLogic($event)" dynamicHeight="true" animationDuration="0ms">
        <mat-tab [disabled]="isReadOnlyMode || disableLocalFormatTab" label="Local format"  mat-stretch-tabs="false" mat-align-tabs="start">
          <div class="form-grid-new tab-grid" [@fadeInOut]>
            <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}"
                 *ngIf="isForceBankNameAndBranchCode">
              <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                                  [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
            </div>
            <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
                 *ngIf="isForceBankNameAndBranchCode">
              <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                                  fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-custom-field type="tel" autocomplete="off" fieldTitle="UK sort code" fieldName="ukSortCode"
                                  [control]="clientBankAccountForm.get('ukSortCode')"></terra-custom-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                                  [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
            </div>
          </div>
        </mat-tab>
        <mat-tab [disabled]="isReadOnlyMode" label="IBAN">
          <p *ngIf="disableLocalFormatTab" class="info-message">
            <ng-container *ngTemplateOutlet="localFormatNotAllowed"></ng-container>
          </p>
          <div class="form-grid-new tab-grid" [@fadeInOut]>
            <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}"
                 *ngIf="isForceBankNameAndBranchCode">
              <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                                  [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
            </div>
            <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
                 *ngIf="isForceBankNameAndBranchCode">
              <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                                  fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. GB29 NWBK 6016 1331 9268 19" [length]="22">
              </terra-iban-field>
            </div>
            <div class="terra-form-field-wrapper">
              <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ANTSGB2L"></terra-swift-field>
            </div>
          </div>
        </mat-tab>
      </mat-tab-group>
    </ng-container>

    <ng-container *ngSwitchCase="'AU'">
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field fieldTitle="Bank name" fieldName="bankName" [control]="clientBankAccountForm.get('bankName')">
        </terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="BSB" fieldName="BSB" [control]="clientBankAccountForm.get('bsb')">
        </terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                            [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. AMPBAU2S">
        </terra-swift-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'ZA'">
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field fieldTitle="Bank name" fieldName="bankName" [control]="clientBankAccountForm.get('bankName')">
        </terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Bank branch code" fieldName="bankBranchCode"
                            [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                            [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ABSAZAJJSLB">
        </terra-swift-field>
      </div>
    </ng-container>

    <ng-container *ngSwitchCase="'IN'">
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field fieldTitle="Bank name" fieldName="bankName" [control]="clientBankAccountForm.get('bankName')">
        </terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-custom-field type="tel" autocomplete="off" fieldTitle="Account number" fieldName="accountNumber"
                            [control]="clientBankAccountForm.get('accountNumber')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ACBLINBB">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'BE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. BE68 5390 0754 7034" [length]="16">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. EBACBEBB">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'FR'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. FR14 2004 1010 0505 0001 3M02 606" [length]="27">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ABCOFRPP">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'DE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. DE89 3704 0044 0532 0130 00" [length]="22">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. AARBDE5W100">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'IT'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. IT60 X054 2811 1010 0000 0123 456" [length]="27">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. VEBHIT2M954">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'NL'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. NL91 ABNA 0417 1643 00" [length]="18">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ABBCNL2A">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'RO'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. RO49 AAAA 1B31 0075 9384 0000" [length]="24">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. RNCBROBUAR0">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'ES'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. ES91 2100 0418 4502 0005 1332" [length]="24">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. CAGLESMMCOP">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'CH'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. CH93 0076 2011 6238 5295 7" [length]="21">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. APHACH22">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'AT'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. AT61 1904 3002 3457 3201" [length]="20">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. RZSTAT2G170">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'CY'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. CY17 0020 0128 0000 0012 0052 7600" [length]="28">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ABKLCY2NLIM">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'BG'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. BG80 BNBG 9661 1020 3456 78" [length]="22">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BUINBGSF">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'HR'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. HR12 1001 0051 8630 0016 0" [length]="21">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. DALMHR22">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'DK'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. DK50 0040 0440 1162 43" [length]="18">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. DKNBDKK3">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'EE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. EE38 2200 2210 2014 5685" [length]="20">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. FOREEE2X">
        </terra-swift-field>
      </div>
    </ng-container>
    <div *ngSwitchCase="'FI'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. FI21 1234 5600 0007 85" [length]="18">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. POPFFI22">
        </terra-swift-field>
      </div>
    </div>
    <ng-container *ngSwitchCase="'GR'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. GR16 0110 1250 0000 0001 2300 695" [length]="27">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BOFAGR2X">
        </terra-swift-field>
      </div>
    </ng-container>
    <div *ngSwitchCase="'HU'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. HU42 1177 3016 1111 1018 0000 0000" [length]="28">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BKCHHUHH">
        </terra-swift-field>
      </div>
    </div>
    <ng-container *ngSwitchCase="'IS'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. IS14 0159 2600 7654 5510 7303 39" [length]="26">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. SISLISRE">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'IE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. IE29 AIBK 9311 5212 3456 78" [length]="22">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. AIBKIE2D">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'LV'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. LV80 BANK 0000 4351 9500 1" [length]="21">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. MULTLV2X">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'LI'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. LI21 0881 0000 2324 013A A" [length]="21">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. SFBALI22">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'LT'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. LT12 1000 0111 0100 1000" [length]="20">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. LIABLT2XSNO">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'LU'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. LU28 0019 4006 4475 0000" [length]="20">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. AAMALULL">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'MT'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. MT84 MALT 0110 0001 2345 MTLC AST0 01S"
                          [length]="31"></terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BAWAMTM3">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'MC'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. MC58 1122 2000 0101 2345 6789 030" [length]="27">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BSILMCMC">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'NO'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. NO93 8601 1117 947" [length]="15">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. CITINOKX">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'PL'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. PL61 1090 1014 0000 0712 1981 2874" [length]="28">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. GOPZPLPW">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'PT'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. PT50 0002 0123 1234 5678 9015 4" [length]="25">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ACTVPTPL">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'SM'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. SM86 U032 2509 8000 0000 0270 100" [length]="27">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ICSMSMSM">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'SK'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. SK31 1200 0000 1987 4263 7541" [length]="24">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. CSDSSKBA">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'SI'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. SI56 2633 0001 2039 086" [length]="19">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. KSPKSI22">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'SE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. SE45 5000 0000 0583 9825 7466" [length]="24">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. FUSASESE">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'CZ'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. CZ65 0800 0000 1920 0014 5399" [length]="24">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BOTKCZPP">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'TR'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. TR33 0006 1005 1978 6457 8413 26" [length]="26">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. AKBKTRIS002">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'GE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. GE29 NB00 0000 0101 9049 17" [length]="22">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. BAGAGE22">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'AE'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. AE07 0331 2345 6789 0123 456" [length]="23">
        </terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper">
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. ABNAAEAA">
        </terra-swift-field>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'UA'">
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankName}" *ngIf="isForceBankNameAndBranchCode"
           [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" fieldTitle="Bank name" fieldName="bankName"
                            [control]="clientBankAccountForm.get('bankName')"></terra-custom-field>
      </div>
      <div [ngClass]="{'terra-form-field-wrapper': true, 'bypass-read-only': isIgnoreReadOnlyBankBranchCode}"
           *ngIf="isForceBankNameAndBranchCode" [@fadeInOut]>
        <terra-custom-field [requiredField]="isForceBankNameAndBranchCode" type="tel" autocomplete="off" fieldTitle="Bank branch code"
                            fieldName="bankBranchCode" [control]="clientBankAccountForm.get('bankBranchCode')"></terra-custom-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-iban-field [control]="clientBankAccountForm.get('iban')" placeholder="e.g. UA21 3223 1300 0002 6007 2335 6600 1"
                          [length]="29"></terra-iban-field>
      </div>
      <div class="terra-form-field-wrapper" [@fadeInOut]>
        <terra-swift-field [control]="clientBankAccountForm.get('swift')" placeholder="e.g. PBANUA2XGR1">
        </terra-swift-field>
      </div>
    </ng-container>
  </ng-container>
  <div *ngIf="showSubmitError === true">
    <strong>{{ error }}</strong>
  </div>
</div>


<!-- Only international format is allowed (no local) -->
<ng-template #localFormatNotAllowed>
  when choosing a currency that is not the local currency in {{ selectedCountry.name }}, Covercy must collect bank account details in
  IBAN-SWIFT format.
</ng-template>
